import { isFetchBaseQueryError } from '../../helpers/isFetchBaseQueryError'

/**
 * The message behind a rejected internal write, so the analyst is told which value the BE refused
 * rather than only that something went wrong.
 *
 * The internal endpoints answer in three shapes: a list of `{ error }` entries (the event
 * endpoints), a `{ message }` body, or a bare string. A bare string is only trusted on a 400, since
 * the body of a 500 is an error page rather than a message. Anything else yields nothing and the
 * caller falls back to its own copy.
 */
export const getValidationErrorMessage = (error: unknown): string | undefined => {
  if (!isFetchBaseQueryError(error)) return undefined

  const { data } = error

  if (typeof data === 'string') return error.status === 400 && data ? data : undefined

  if (typeof data !== 'object' || data === null) return undefined

  const { errors, message } = data as { errors?: unknown; message?: unknown }

  if (Array.isArray(errors)) {
    const listed = errors
      .map((entry) => (typeof entry === 'object' && entry !== null ? (entry as { error?: unknown }).error : entry))
      .find((entry): entry is string => typeof entry === 'string' && entry.length > 0)
    if (listed) return listed
  }

  return typeof message === 'string' && message ? message : undefined
}
